
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[nickname]/shared/[publicLink]",
      function () {
        return require("private-next-pages/[nickname]/shared/[publicLink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[nickname]/shared/[publicLink]"])
      });
    }
  